<template>
  <div class="menu-container">
    <MenuSection :listItems="filteredResults" />
  </div>
</template>

<script>
import MenuSection from "./MenuSection.vue";
import { mapGetters } from "vuex";

export default {
  name: "FilteredResults",
  components: {
    MenuSection
  },
  computed: mapGetters(["filteredResults"])
};
</script>

<style scoped>
.menu-container {
  width: 100%;
  column-count: 1;
  column-gap: 0;
}
</style>